import React from 'react';

type SaveBoardIconProps = {
  width?: number;
  height?: number;
  color?: string;
  isSaved?: boolean;
};

export const SaveBoardIcon = ({
  width = 14,
  height = 14,
  color = 'currentColor',
  isSaved = false,
}: SaveBoardIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.497 7.49939H15.1651C13.1486 7.49939 11.4988 9.14926 11.4988 11.1658V40.4967L24.3311 34.9972L37.1634 40.4967V11.1658C37.1634 9.14926 35.5135 7.49939 33.497 7.49939Z"
      stroke={color}
      fill={isSaved ? color : 'none'}
      strokeWidth="2.4998"
    />
  </svg>
);
